import * as React from 'react';
import { useEffect, useState } from "react";
import { ApiGet, ApiPatch } from '../../helper/API/ApiData';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { Fieldset } from 'primereact/fieldset';
import { Avatar } from 'primereact/avatar';
import { getHeading } from '../../utils/helper';
import { Button } from 'primereact/button';
import { TextField } from '@mui/material';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setGroupMemberDetail } from '../../redux/actions/groupMemberDetailActions';
import { Badge } from 'primereact/badge';


interface IGroupMemberHomePageProps {
}

type Member = {
    name: string
}
type GroupMemberDetails = {
    id: string
    designation?: string
    no_of_months_in_job?: number
    isActive: boolean,
    member: Member
}
export const GroupMemberHome = (props: IGroupMemberHomePageProps) => {

    const { group_member_id } = useParams();

    const dispatch = useDispatch()

    // const [groupMemberDetails, setGroupMemberDetails] = useState<GroupMemberDetails[]>([])

    const groupMemberDetails = useSelector((store: any) => store.groupMemberDetail.groupMemberDetails)

    const [designation, setDesignation] = useState("")
    const [numOfMonths, setNumOfMonths] = useState(0)

    useEffect(() => {
        // Get GroupMember Details
        if (groupMemberDetails === null) {
            ApiGet(`group_member/id/${group_member_id}`)
                .then((res: any) => {
                    if (res?.status === 200) {
                        // setGroupMemberDetails(res?.data)
                        dispatch(setGroupMemberDetail(res.data[0]))
                        // Get member details
                        setDesignation(groupMemberDetails.designation)
                        setNumOfMonths(groupMemberDetails.no_of_months_in_job === null ? NaN : groupMemberDetails.no_of_months_in_job)
                    }
                })
                .catch((error) => {
                    return error
                })
        }
        else {
            setDesignation(groupMemberDetails.designation)
            setNumOfMonths(groupMemberDetails.no_of_months_in_job === null ? NaN : groupMemberDetails.no_of_months_in_job)
        }

    }, [groupMemberDetails]);

    const legendTemplate = (heading: string) => {
        return (
            <>
                <div className="flex align-items-center gap-2 px-2 p-overlay-badge">

                    <Avatar label={heading[0]} size="large" />
                    <span className="font-bold" style={{ marginLeft: "15px" }}>
                        {heading}
                    </span>
                    {groupMemberDetails.isActive ?
                        <Badge value="active" severity="success"></Badge>
                        :
                        <Badge value="removed" severity="danger"></Badge>
                    }
                </div>
            </>
        )
    }

    const handleSubmit = (groupDetailId: string) => {
        // Save the groupDetails 
        const data = {
            no_of_months_in_job: Number.isNaN(numOfMonths) ? null : numOfMonths,
            designation: designation !== "" ? designation : null
        }
        ApiPatch(`group_member/${groupDetailId}`, data)
            .then((res: any) => {
                if (res.status === 200) {
                    toast.success("Successfully updated details")
                    dispatch(setGroupMemberDetail(null))
                }
            }).catch((error) => {
                if (error.status === 400 && error.code === 'validation_error') {
                    error.data.validation.body.keys
                }
                return error
            })

    }

    return (
        <>
            {groupMemberDetails !== null &&
                <Fieldset legend={legendTemplate(groupMemberDetails.member.name)}
                    style={{
                        border: "1px solid #e5e7eb",
                        color: "#374151",
                        background: "#fff",
                        borderRadius: "6px",
                        backgroundColor:  groupMemberDetails.member.isActive ? "#fff" : "#c8c8c8",
                    }}
                    pt={{
                        legend: {
                            style: {
                                float: "none",
                                padding: "1.25rem",
                                color: "#374151",
                                background: "#fff",
                                borderRadius: "6px",
                                width: "auto"
                            }
                        }

                    }}>
                    {!groupMemberDetails.member.isActive && 
                    <Row>
                        <Col xl={12} sm={12} md={12}>
                            <p style={{ color: "red" }}>Member has been deleted</p>
                        </Col>
                    </Row>
                    }
                    <Row style={{ marginBottom: "20px" }}>
                        <Col xl={4} sm={4} md={4}>
                            <TextField type="number"
                                value={numOfMonths}
                                disabled={!groupMemberDetails.isActive}
                                onChange={(e) => setNumOfMonths(parseInt(e.target.value))}
                                label="Number of Months in job" />
                        </Col>
                        <Col xl={4} sm={4} md={4}>
                            <TextField type="text"
                                disabled={!groupMemberDetails.isActive}
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value)}
                                label="Designation" />
                        </Col>
                        <Col xl={4} sm={4} md={4}>
                            {groupMemberDetails.isActive &&
                                <Button icon="pi pi-pencil" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="info" onClick={() => handleSubmit(groupMemberDetails.id)} />
                            }
                        </Col>
                    </Row>
                    <Row>
                        {Object.entries(groupMemberDetails.member).map(([key, value]: any) => {
                            // Pretty straightforward - use key for the key and value for the value.
                            // Just to clarify: unlike object destructuring, the parameter names don't matter here.
                            if (!(['name', 'createdAt', 'updatedAt', 'isActive', 'id'].includes(key))) {
                                if (typeof value === 'boolean') {
                                    return (
                                        <Col xl={4} sm={4} md={4}>
                                            <dl>
                                                <dt>{getHeading(key)}</dt>
                                                <dd>{value ? 'Yes' : 'No'}</dd>
                                            </dl>

                                        </Col>
                                    )
                                }
                                else {

                                    return (
                                        <Col xl={4} sm={4} md={4}>
                                            <dl>
                                                <dt>{getHeading(key)}</dt>
                                                <dd>{value}</dd>
                                            </dl>
                                        </Col>
                                    )
                                }
                            }
                        })}
                    </Row>
                </Fieldset>
            }
        </>


    );
};
